import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { Link } from 'react-router-dom';
import { HomeDelivery as HomeDeliveryComponent } from '../home-delivery';
import LocationAndCurrencyInfoComponent from '../../../../../../../components/location-and-currency-info';
import SotyBadgeComponent from '../../../../../../store/components/soty-badge-link/soty-badge';
import { H4Text } from '@prisjakt/ui/text/variants';

export const ExpandedInfo = styled.div`
  padding: ${layout.measurements.spacing100};
  display: flex;
  justify-content: space-between;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr auto;
  }

  ${media.smallOnly`
    grid-template-columns: 1fr;
    padding: 0;
  `}

  > div {
    flex: 0 0 48%;

    .sentiment-badge--text > span {
      display: block;
      margin-left: 0;
    }
  }
`;

export const Title = styled.h3`
  margin: 0;
`;

export const StoreLink = styled(H4Text)`
  display: flex;
  align-items: center;
  margin-bottom: ${layout.measurements.spacing025};
  > svg > path {
    fill: currentColor;
  }
`;

export const GeneralInfo = styled.div`
  grid-area: 2 / 1 / 3 / 3;
`;

export const StoreInfoLink = styled(Link)`
  display: block;
  text-decoration: underline;
  margin-bottom: 1rem;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const StoreInfoRowItem = styled.div`
  margin-bottom: 1rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const HomeDelivery = styled(HomeDeliveryComponent)`
  margin-bottom: ${layout.measurements.spacing050};
`;

export const LocationAndCurrencyInfo = styled(LocationAndCurrencyInfoComponent)`
  margin-bottom: ${layout.measurements.spacing100};
  align-items: baseline;
`;

export const SotyBadge = styled(SotyBadgeComponent)`
  margin: ${layout.measurements.spacing025};
  align-items: normal;

  ${media.smallOnly`
    max-width: 88px;
  `}
`;

export const PaymentProviders = styled.div`
  display: flex;
  gap: ${layout.measurements.spacing050};
  align-items: center;
`;
